export const login_i18n = {
  // Brand panel on the sign-in screen. Short and concrete: what the
  // product does, not how well it does it.
  panelKicker: "WACheckin · 2026",
  panelCta: "Poznaj WACheckin",
  partnersLabel: "Połączone z",
  // Cards in the panel scene.
  escena: {
    reservas: "Rezerwacje",
    mensajes: "Automatyczne wiadomości",
    llaves: "Klucze cyfrowe",
    checkin: "Check-in online",
    cobros: "Automatyczne płatności",
    autoridades: "Służby i zgodność z przepisami",
  },

  // Step 2: the code that arrives by email.
  verify: {
    title: "Sprawdź swoją skrzynkę e-mail",
    titleWhatsapp: "Sprawdź WhatsApp",
    sending: "Wysyłanie…",
    destinoWhatsapp: "Zostanie wysłany na numer",
    destinoCorreo: "Zostanie wysłany na adres",
    intro: "Wysłaliśmy {largo}-cyfrowy kod na adres",
    submit: "Zaloguj się",
    submitting: "Sprawdzanie...",
    back: "Użyj innego konta",
    resendAsk: "Kod nie dotarł?",
    resend: "Wyślij kod ponownie",
    resendWait: "Ponowne wysłanie za {s}s",
    resendDone: "Nowy kod został wysłany.",
    expires: "Kod wygasa za {tiempo}",
    expired: "Kod wygasł. Poproś o nowy.",
    digitAria: "Cyfra {n} z {total}",
    otroMetodo: "E-mail nie dotarł?",
    porWhatsapp: "Odbierz kod na WhatsApp",
    preferesCorreo: "Wolisz e-mail?",
    porCorreo: "Odbierz kod e-mailem",
    introWhatsapp: "Wysłaliśmy {largo}-cyfrowy kod przez WhatsApp na numer",
    enviadoWhatsapp: "Kod został wysłany na WhatsApp.",
  },
  langLabel: "Język",
  panelTitle: "Wszystkie obiekty zautomatyzowane dzięki AI",
  panelDesc: "Check-in, wiadomości, klucze, płatności i meldunek w służbach. Jeden panel do wszystkiego.",

  bannerAlt: "tło ekranu logowania",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "pokaż lub ukryj hasło",

  title: "Witamy ponownie!",
  infoTitle: "Jeśli masz już konto, zaloguj się swoim adresem e-mail.",
  infoDesc: "Jeśli nie masz jeszcze konta, możesz je założyć poniżej.",

  emailLabel: "E-mail",
  emailPlaceholder: "Wpisz swój adres e-mail",

  passwordLabel: "Hasło",
  passwordPlaceholder: "Wpisz swoje hasło",

  forgot: "Nie pamiętasz hasła?",

  submit: "Zaloguj się",
  submitting: "Logowanie...",

  noAccount: "Nie masz konta?",
  signup: "Zarejestruj się",

  terms: "Regulamin",
  privacy: "Polityka prywatności",
  copyright: "© 2024–{anio} WA Checkin. Wszelkie prawa zastrzeżone.",

  resetSuccess: "Wysłaliśmy wiadomość e-mail, aby zresetować hasło.",

  errors: {
    default: "Logowanie nie powiodło się.",
    network: "Błąd połączenia. Spróbuj ponownie.",
  },
  resetPassword: {
    title: "Zresetuj hasło",
    infoTitle: "Wyślemy e-mailem link do resetowania hasła",
    infoDesc:
      "Podaj swój adres e-mail, a otrzymasz instrukcję resetowania hasła.",

    labels: {
      email: "Adres e-mail",
    },

    placeholders: {
      email: "imie@email.com",
    },

    hints: {
      email: "Upewnij się, że podajesz adres e-mail użyty przy rejestracji.",
    },

    buttons: {
      send: "Wyślij",
      sending: "Wysyłanie...",
    },

    successTitle: "Gotowe!",
    successDesc: "Sprawdź skrzynkę odbiorczą (oraz spam).",

    aria: {
      close: "zamknij",
    },

    toasts: {
      emailRequired: "Podaj swój adres e-mail.",
      sent: "Wysłaliśmy e-mail z instrukcją.",
      userNotFound: "Nie znaleziono użytkownika.",
      networkError: "Błąd połączenia. Spróbuj ponownie.",
    },
  },

  
  common: {
    ok: "OK",
    cancel: "Zamknij",
  },
};
